import {Chip, InputAdornment, TextField} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddIcon from '@mui/icons-material/Add';
import React, {useState} from "react";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";

const FieldWithButtonAndChips = ({name, label, value, setCurrValues}) => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };

    const handleButtonClick = () => {
        const newData = [...value, inputValue]
        setCurrValues(prev => ({...prev, [name]: newData}))
        setInputValue("")
    };

    const handleDelete = (i) => {
        const newData = value.filter((e, index) => {
            return i !== index
        })

        setCurrValues(prev => ({...prev, [name]: newData}))
    }
    return <Box sx={{display: "flex", flexDirection: "column", gap: "5px"}}>
        <TextField
            autoComplete={"off"}
            sx={{width: "100%", height: "40px"}}
            label={label}
            variant="outlined"
            value={inputValue}
            onChange={handleInputChange}
            size={"small"}
            type={"number"}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleButtonClick}
                            edge="end"
                        >
                            <AddIcon/>
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
        <Box sx={{display: "flex", height: "32px", alignItems: "center"}}>
            <Typography> Диаметры сверл:</Typography>
            {value?.map((el, i) => {
                return <Chip
                    key={i}
                    label={el}
                    onDelete={() => handleDelete(i)}
                />
            })}
        </Box>

    </Box>
}
export default FieldWithButtonAndChips